import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import useTooltip from '../../tooltip/hooks/useTooltip';

function ConnectedPlayMiniButton({
  id, direction, size = 20, color = `#262626`, arrowColor = 'white',
  onClick, className, style, disable,
  isTablet = false
}) {
  useTooltip(id, `Load Buttons`, `Load track to deck ${direction === `left` ? `A` : `B`}`);

  return (
    <div id={id} className={`play-mini-button ${disable && `disable`} ${isTablet && `tablet` } ${className}`} style={{...style}} onClick={!disable ? onClick : null}>
      {(direction === `left`) ? (
        <svg  width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect  width={size} height={size} className={`container-play-mini-button ${className}`} rx="2" fill={color}/>
          <path className={`play-mini-button-arrow`} d="M6.07894 10.4085C5.79664 10.2093 5.79664 9.79067 6.07894 9.59147L11.4617 5.79311C11.7929 5.55939 12.25 5.79626 12.25 6.20164L12.25 13.7984C12.25 14.2037 11.7929 14.4406 11.4617 14.2069L6.07894 10.4085Z" fill={arrowColor} />
        </svg>
      ) : (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x={size} y={size} width={size} height={size} className={`container-play-mini-button ${className}`} rx="2" transform="rotate(-180 20 20)" fill={color}/>
          <path  className={`play-mini-button-arrow`} d="M13.9211 9.59147C14.2034 9.79067 14.2034 10.2093 13.9211 10.4085L8.53828 14.2069C8.20706 14.4406 7.75 14.2037 7.75 13.7984L7.75 6.20164C7.75 5.79626 8.20706 5.55939 8.53828 5.79311L13.9211 9.59147Z" fill={arrowColor}/>
        </svg>
      )
    }
    </div>
  )
}

ConnectedPlayMiniButton.propTypes = {
  id: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  color: PropTypes.string,
  arrowColor: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
}

const PlayMiniButton = connect(
  state => ({
    disable: !!state.uidAutomix,
    isTablet: state.layoutTablet
  })
)(ConnectedPlayMiniButton);

export default PlayMiniButton;
